// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AuthenticationV2UserCreateAnyPortalStandardUserCreateAnyPortalStandardUserResponse {
    static getAttributeTypeMap() {
        return AuthenticationV2UserCreateAnyPortalStandardUserCreateAnyPortalStandardUserResponse.attributeTypeMap;
    }
}
AuthenticationV2UserCreateAnyPortalStandardUserCreateAnyPortalStandardUserResponse.discriminator = undefined;
AuthenticationV2UserCreateAnyPortalStandardUserCreateAnyPortalStandardUserResponse.additionalProperties = false;
AuthenticationV2UserCreateAnyPortalStandardUserCreateAnyPortalStandardUserResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
];
//# sourceMappingURL=authenticationV2UserCreateAnyPortalStandardUserCreateAnyPortalStandardUserResponse.js.map